interface StepHeadingProps {
  step: number;
  title: string;
  hint?: string;
}

/**
 * Шаг формы публикации. Форма длинная, и без опор глаз теряет, где кончается
 * одна мысль и начинается другая: «куда публикуем» → «как выглядит» → «когда».
 */
export function StepHeading({ step, title, hint }: StepHeadingProps): JSX.Element {
  return (
    <div className="flex items-baseline gap-2.5 pt-2 first:pt-0">
      <span className="flex size-5 shrink-0 translate-y-0.5 items-center justify-center rounded-full bg-primary/10 text-[11px] font-semibold text-primary">
        {step}
      </span>
      <div className="min-w-0">
        <p className="text-sm font-semibold">{title}</p>
        {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      </div>
    </div>
  );
}
